// Utils
import createDeepEqualSelector from 'utils/reselect/createDeepEqualSelector';
import keyBy from 'lodash.keyby';

const selectWorkTypes = (state) => state.workTypes;
const selectWorkTypeId = (state, props) =>
    props.workTypeId && `${props.workTypeId}`;

const selectWorkTypesArray = createDeepEqualSelector(
    selectWorkTypes,
    (workTypesState) => Object.values(workTypesState)
);

const selectWorkTypesExist = createDeepEqualSelector(
    selectWorkTypesArray,
    (workTypesArrayState) => !!workTypesArrayState.length
);

const selectWorkType = createDeepEqualSelector(
    [selectWorkTypes, selectWorkTypeId],
    (workTypesState, workTypeIdProp) =>
        workTypeIdProp && workTypesState[workTypeIdProp]
);

const makeSelectWorkTypeValue = (field) =>
    createDeepEqualSelector(
        selectWorkType,
        (workTypeState) => workTypeState && workTypeState[field]
    );

const selectWorkTypesKeyedByName = createDeepEqualSelector(
    selectWorkTypesArray,
    (workTypesArray) => keyBy(workTypesArray, 'name')
);

export {
    selectWorkTypes,
    selectWorkTypesArray,
    selectWorkTypesExist,
    selectWorkType,
    makeSelectWorkTypeValue,
    selectWorkTypesKeyedByName
};
